module.exports = __webpack_public_path__ + "static/img/page51.b86a188.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page51.jpg
// module id = 2oni
// module chunks = 0